import {
  // SET_ADVERTISERS,
  // CHANGE_ADVERTISER_STATUS,
  // REMOVE_ADVERTISER,
  // SET_BUSINESS,
  // SET_BUSINESSES,
  // CHANGE_BUSINESS_STATUS,
  // REMOVE_BUSINESS,
  // CREATE_BUSINESS,
  // SET_CURRENT_ADVERTISEMENTS,
  // SET_CURRENT_ADVERTISEMENT,
  // REMOVE_ADVERTISEMENT,
  // CREATE_ADVERTISEMENT,
  // MODIFY_ADVERTISEMENT,
  // CHANGE_ADVERTISEMENT_STATUS,
  // SET_IMAGES,
  // SET_NEW_IMAGE,
  // REMOVE_IMAGE,
  SET_IS_LOADING,
  SET_CURRENT_DEALS,
  SET_DOMAIN_DATA,
  SET_CURRENT_ACCOMMODATIONS,
  MODIFY_ACCOMMODATION,
  INSERT_ACCOMMODATION,
  DELETE_ACCOMMODATION,
  DELETE_ACCOMMODATIONS_FOR_PROPERTY,
  CHANGE_ACCOMMODATION_STATUS,
  SET_CURRENT_PROPERTIES,
  MODIFY_PROPERTY,
  INSERT_PROPERTY,
  DELETE_PROPERTY,
  CHANGE_PROPERTY_STATUS

} from "../actions/types";

// import { TEST_DISPATCH } from "../actions/types";

const initialState = {
  deals: [],
  min_ppn: 1000,
  max_ppn: 0,
  min_lok: 1000,
  max_lok: 0,
  min_millis: 0,
  max_millis: 0,
  min_start: 0,
  max_start: 0,
  // min_start2: null,
  // max_start2: null,
  delta_start_millis: 0,
  available_weeks_range: [0, 56],
  current_cities: [],
  current_states: [],
  current_lok: [],
  current_accommodations: [],
  current_properties: [],
  isloading: false
};
// let bizid = "";
// let workid = "";
// let workobj = {};
export default function (state = initialState, action) {
  // console.log("adverreducer ", action.type);
  // console.log("adverreducer ", action.payload);
  let bizid = "";
  let recid = "";
  let workcollection = [];
  let workpayload = {};
  let workary = [];
  let workid = "";
  let status = 0;
  let updatestatus = 0;
  let workdeals = [];
  let deals = [];
  let domain_data = {};

  switch (action.type) {
    // *************************
    // ADVERTISER
    // *************************

    case SET_IS_LOADING:
      return {
        ...state,
        isloading: action.payload.isloading,
      };

    case SET_CURRENT_DEALS:
      let wdeals = action.payload;
      let sd = state.delta_start_millis;
      let ucities = [];
      let ustates = [];
      let ulok = [];
      // console.log('reducer delta_start_millis', state.delta_start_millis);
      wdeals.forEach(d => {

        if (ucities.indexOf(d['city']) < 0) ucities.push(d['city']);
        if (ustates.indexOf(d['state']) < 0) ustates.push(d['state']);
        if (ulok.indexOf(d.accommodations['lok']) < 0) ulok.push(d.accommodations['lok']);

      });
      ucities.unshift('Any');
      ustates.unshift('Any');
      ulok.unshift('Any');

      return {
        ...state,
        deals: wdeals, //action.payload
        current_cities: ucities,
        current_states: ustates,
        current_lok: ulok
      };

    case SET_CURRENT_ACCOMMODATIONS:
      return {
        ...state,
        current_accommodations: action.payload
      };

    case SET_CURRENT_PROPERTIES:
      return {
        ...state,
        current_properties: action.payload
      };

    case MODIFY_ACCOMMODATION:
      let updateobj = action.payload;
      // let updateobj = pdata['updateobj'];
      let oid = updateobj['_id'];

      let curaccoms = state.current_accommodations;
      workary = [];
      curaccoms.forEach(el => {
        if (el['_id'] === oid) {
          // el = updateobj;
          workary.push(updateobj);
        } else {
          workary.push(el);
        }
      })

      return {
        ...state,
        current_accommodations: workary
      };

    case MODIFY_PROPERTY:
      workpayload = action.payload;
      recid = workpayload['_id'];

      let curprops = state.current_properties;
      workary = [];
      curprops.forEach(el => {
        if (el['_id'] === recid) {
          // el = updateobj;
          workary.push(workpayload);
        } else {
          workary.push(el);
        }
      })

      return {
        ...state,
        current_properties: workary
      };

    case INSERT_PROPERTY:
      workpayload = action.payload;

      workary = state.current_properties;
      workary.push(workpayload)
      // let pnewary = [];
      // curprops.forEach(el => {
      //     pnewary.push(el);
      // });
      // pnewary.push(workpayload)

      return {
        ...state,
        current_properties: workary
      };

    case INSERT_ACCOMMODATION:
      workpayload = action.payload;

      workary = state.current_accommodations;
      workary.push(workpayload);


      return {
        ...state,
        current_accommodations: workary //state.current_accommodations.push(action.payload)
      };

    case CHANGE_ACCOMMODATION_STATUS:
      workary = state.current_accommodations;
      recid = action.payload.acomid;
      status = action.payload.status;
      updatestatus = 0;
      if (status == 0) {
        updatestatus = 1;
      }
      workary.map((a, index) => {
        if (a._id == recid) {
          a.status_flag = updatestatus;
        }
      });
      return {
        ...state,
        current_accommodations: workary
      };

    case CHANGE_PROPERTY_STATUS:
      workary = state.current_properties;
      recid = action.payload.propid;
      status = parseInt(action.payload.status);
      updatestatus = 0;
      if (status == 0) {
        updatestatus = 1;
      }
      workary.map((p, index) => {
        if (p._id == recid) {
          p.status_flag = updatestatus;
        }
      });
      return {
        ...state,
        current_properties: workary
      };

    case DELETE_ACCOMMODATION:
      recid = action.payload;
      //images: state.images.filter(item => item.businessId !== workid),
      return {
        ...state,
        current_accommodations: state.current_accommodations.filter(item => item._id !== recid)
      };

    case DELETE_ACCOMMODATIONS_FOR_PROPERTY:
      recid = action.payload;
      //images: state.images.filter(item => item.businessId !== workid),
      return {
        ...state,
        current_accommodations: [] //state.current_accommodations.filter(item => item._id !== propkey)
      };



    case DELETE_PROPERTY:
      recid = action.payload;
      //images: state.images.filter(item => item.businessId !== workid),
      return {
        ...state,
        current_properties: state.current_properties.filter(item => item._id !== recid)
      };


    case SET_DOMAIN_DATA:
      let dd = action.payload;
      let minppn = 1000;
      let maxppn = 0;
      let minlok = 1000;
      let maxlok = 0;
      let mindate = new Date('2050-01-10').getTime();
      let maxdate = new Date('2000-01-01').getTime();
      //let minmillis = 1544313600000;
      // let minmillis = 1600000000000000;
      // let maxmillis = 0;
      // let minstart = null;
      // let maxstart = null
      let deltastartmillis = new Date().getTime();
      dd.forEach(el => {
        let ppn = parseInt(el['ppn']);
        if (ppn > maxppn) maxppn = ppn;
        if (ppn < minppn) minppn = ppn;
        let lok = parseInt(el['lok']);
        // let sdate = el['start_date'];
        if (lok > maxlok) maxlok = lok;
        if (lok < minlok) minlok = lok;
        let sd = new Date(el['start_date']).getTime();
        if (sd < mindate) mindate = sd;
        let ed = new Date(el['end_date']).getTime();
        if (sd > maxdate) maxdate = ed;



      });
      let rmin = Math.round(minppn / 10) * 10
      let rmax = (Math.round(maxppn / 10) + 1) * 10
      //  console.log('mins', minppn, rmin);
      //  console.log('maxs', maxppn, rmax);
      // console.log('minmillis date ', minmillis, new Date(minmillis));
      //console.log('minmillis table date now', new Date());

      console.log('mindate is ', mindate, ' data ', new Date(mindate));

      deltastartmillis = deltastartmillis - mindate; //new Date(mindate).getTime(); //minmillis + (24 * 60 * 60 * 1000);
      console.log('delta days ', parseInt(deltastartmillis / (1000 * 60 * 60 * 24)));
      return {
        ...state,
        domain_data: action.payload,
        min_ppn: rmin,
        max_ppn: rmax,
        min_lok: minlok,
        max_lok: maxlok,
        // min_millis: minmillis,
        // max_millis: maxmillis,
        // min_start: minstart,
        // max_start: maxstart,
        min_start: mindate,
        max_start: maxdate,
        delta_start_millis: deltastartmillis
      };






    // *************************
    // ADVERTISEMENTS
    // *************************






    // *************************
    // IMAGES
    // *************************

    // return state;

    // case TEST_DISPATCH:
    //   console.log("we are in authreducer " + action.type);
    //   return {
    //     ...state,
    //     user: action.payload
    //   };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/dealsReducer.js